import axios from 'src/utils/axios';
import * as Sentry from '@sentry/browser';
import { stripNull } from 'src/utils/object';

const baseURL = '/public/medicalReview';

class MedicalReviewService {
  getPathology = async (caseId) => {
    try {
      const request = await axios.get(`${baseURL}/${caseId}/pathology`);
      if (request.status === 200) {
        return request.data.pathology;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  createPathology = async (caseId, payload) => {
    try {
      const request = await axios.post(
        `${baseURL}/${caseId}/pathology`,
        payload,
      );
      if (request.status === 200) {
        return request.data.pathology;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  /* DONOR INFORMATION */
  updatePathology = async (caseId, payload) => {
    try {
      const request = await axios.put(
        `${baseURL}/${caseId}/pathology`,
        payload,
      );
      if (request.status === 200) {
        return request.data.pathology;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  /** Medical summary */
  getMedicalReviewSummary = async (caseId) => {
    try {
      const request = await axios.get(`${baseURL}/${caseId}/summary`);
      if (request.status === 200) {
        if (request.data.record.previouslyOnVent) {
          const [time, units] = (request.data.record.durationVent || ' ').split(
            ' ',
          );
          request.data.record.durationVentTime = time;
          request.data.record.durationVentUnits = units;
        }
        return request.data.record;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  upsertMedicalReviewSummary = async (caseId, payload) => {
    try {
      if (payload.previouslyOnVent) {
        payload.durationVent = `${payload.durationVentTime} ${payload.durationVentUnits}`;
      } else {
        payload.durationVent = null;
      }
      delete payload.durationVentTime;
      delete payload.durationVentUnits;

      const request = await axios.post(`${baseURL}/${caseId}/summary`, payload);
      if (request.status === 200) {
        if (request.data.record.previouslyOnVent) {
          const [time, units] = (request.data.record.durationVent || ' ').split(
            ' ',
          );
          request.data.record.durationVentTime = time;
          request.data.record.durationVentUnits = units;
        }
        return request.data.record;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  updateMedicalReviewSummaryPriority = async (caseId, payload) => {
    try {
      const request = await axios.put(
        `${baseURL}/${caseId}/summary/priority`,
        payload,
      );
      if (request.status === 200) {
        return request.data.record;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  /** Culture Results */
  getCultureResults = async (caseId) => {
    try {
      const request = await axios.get(`${baseURL}/${caseId}/cultureResult`);
      if (request.status === 200) {
        return request.data.record;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  updateCultureResults = async (caseId, payload) => {
    try {
      const request = await axios.post(
        `${baseURL}/${caseId}/cultureResult`,
        payload,
      );
      if (request.status === 200) {
        return request.data.item;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  /** Lab Values service */
  getLabValues = async (caseId) => {
    try {
      const request = await axios.get(`${baseURL}/${caseId}/labValues`);
      if (request.status === 200) {
        return request.data.record;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };

  upsertLabValues = async (caseId, payload) => {
    try {
      const request = await axios.post(
        `${baseURL}/${caseId}/labValues`,
        payload,
      );
      if (request.status === 200) {
        return request.data.record;
      }
      throw new Error(request.data.message);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  };
}
const medicalReviewService = new MedicalReviewService();

export default medicalReviewService;
